'use strict'

import * as stateKeys from './constants/state-keys'

export default {
  [stateKeys.IS_EVENTS_JSON_LOADED]: false,
  [stateKeys.EVENTS_JSON]: []
}
